import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { Button } from "components";
import { LineDivider } from "components/layout";
import { useQaCompleteMutation, useQaDeclineMutation } from "queries";
import { uiActions } from "store";
import { UWDecisions } from "types";
import {
	uwDeclineDecisions,
	uwQaCompleteDecisions,
} from "types/enums/uwDecisions";

import getApproveNoteText from "./getApproveNoteText";

import styles from "./underwritingForm.module.scss";

const UnderwritingQaDecisionActions = ({ decisionData }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const { id } = useParams();

	const { mutate: onQaDecline } = useQaDeclineMutation();
	const { mutate: onQaComplete } = useQaCompleteMutation();

	const approveNoteText = useMemo(
		() => getApproveNoteText(decisionData),
		[decisionData],
	);

	const showDeclineModal = () => {
		dispatch(
			uiActions.showModal("UW_DECISION", {
				decisions: uwDeclineDecisions,
				onSubmit: values =>
					onQaDecline({ data: values, applicationId: id }),
				title: "Underwriting Decline",
				subTitle: "Are you sure you want to decline the application",
				buttonText: "Decline",
				defaultValues: {
					decision: UWDecisions.DeclinedDoesNotMeetJurisdictionReqs,
					title: `Underwriting ${UWDecisions.DeclinedDoesNotMeetJurisdictionReqs.displayName}`,
					note: "",
				},
			}),
		);
	};

	const showQACompleteModal = () => {
		dispatch(
			uiActions.showModal("UW_DECISION", {
				decisions: uwQaCompleteDecisions,
				onSubmit: values =>
					onQaComplete({
						data: values,
						applicationId: id,
					}),
				title: "Underwriting QA Complete",
				subTitle: "Are you sure you want to complete the application?",
				buttonText: "QA Complete",
				defaultValues: {
					decision: UWDecisions.Approved,
					title: `Underwriting ${UWDecisions.Approved.displayName}`,
					note: approveNoteText,
				},
			}),
		);
	};

	const handleQaDecline = () => showDeclineModal();
	const handleQAComplete = () => showQACompleteModal();
	const handleAddZendeskTicket = () =>
		history.push(`/underwriting/qa-in-progress/${id}/tickets/new`);

	return (
		<div className={styles.wrappUwBtn}>
			<LineDivider />
			<div className={styles.wrappFooterBtn}>
				<div className={styles.footerBtn}>
					<Button
						className={styles.declineBtn}
						onClick={handleQaDecline}
						value="Decline"
						variant="danger"
					/>
				</div>

				<div className={styles.footerBtn}>
					{/* Add Zendesk Ticket */}
					<Button
						className={styles.pendedBtn}
						value="Ticket"
						variant="warning"
						onClick={handleAddZendeskTicket}
					/>
				</div>

				<div className={styles.footerBtn}>
					<Button
						className={styles.approveBtn}
						onClick={handleQAComplete}
						value="QA Complete"
						variant="success"
					/>
				</div>
			</div>
		</div>
	);
};

export default UnderwritingQaDecisionActions;
